import type { Element } from "React";
type Props = {
  className?: string;
};

const IconFavorite = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 80 80"
    className={`icon--empty-favourites`}
  >
    <g transform="translate(6 6)">
      <path d="M45.32 7.446A31.376 31.376 0 0 0 32 4.5C14.603 4.5.5 18.603.5 36S14.603 67.5 32 67.5 63.5 53.397 63.5 36c0-4.644-1.005-9.145-2.92-13.263L45.32 7.447z" />
      <circle cx="56" cy="12" r="11.5" />
      <text>
        <tspan x="52" y="17">
          0
        </tspan>
      </text>
      <path d="M41.308 51.398l-1.842-11.293 7.83-8.026-10.818-1.652-4.811-10.25-4.811 10.25-10.819 1.652 7.83 8.026-1.842 11.293 9.642-5.33 9.641 5.33z" />
    </g>
  </svg>
);

export default IconFavorite;
